import {
  createEventServiceClient,
  EventServiceClient,
} from '@thyme/libs/src/events/eventServiceClient'
import { MonitoringEvent } from './types'

let client: EventServiceClient | null = null

/**
 *
 * @param opts
 * @param opts.eventService
 * @param opts.eventService.url
 * @param opts.eventService.apiKey
 * @param opts.isLocal
 */
// IMPROVEME(TEA-1018): no-ops until eventService config is wired with real values
export function initializeEventService(opts: {
  eventService?: { url: string; apiKey: string }
  isLocal: boolean
}): void {
  if (!opts.eventService) {
    console.debug('Skipping event service initialization (not configured)')
    return
  }
  client = createEventServiceClient({
    url: opts.eventService.url,
    apiKey: opts.eventService.apiKey,
    isLocal: opts.isLocal,
  })
}

/**
 *
 * @param event
 */
export async function sendMonitoringEvent(
  event: MonitoringEvent
): Promise<void> {
  if (!client) return
  await client.sendEvent(event.event, event.data)
}
